import consumer from "./consumer"

$(document).on('turbolinks:load', function () {
  const currentUserElement = $('#current-user');
  const guestChatConfig = $('#public-guest-chat-config');
  var currentUserId = currentUserElement.data('user-id');
  const currentUserTypeValue = currentUserElement.data('user-type');

  if ((currentUserId === undefined || currentUserId === null || currentUserId === "") && guestChatConfig.length > 0) {
    const guestSenderId = parseInt(guestChatConfig.data('sender-id'), 10);
    currentUserId = Number.isNaN(guestSenderId) ? currentUserId : guestSenderId;
  }

  var currentUserType = (currentUserTypeValue === "" || currentUserTypeValue === undefined || currentUserTypeValue === null) ? "SenderProfile" : "ShipperProfile";
  if (guestChatConfig.length > 0) {
    currentUserType = guestChatConfig.data('sender-type') || "SenderProfile";
  }
  var room_ids = []
  var result=document.querySelectorAll('[data-room-id]');
  for (var index in result){
    if (result.hasOwnProperty(index)){
      room_ids.push(result[index].getAttribute('data-room-id'))
    }
  }
  $.each(room_ids, function(index, room_id) {

    consumer.subscriptions.create({channel: "RoomChannel", room_id: room_id}, {
      connected() {
        console.log("connected...");
        // Called when the subscription is ready for use on the server
      },

      disconnected() {
        // Called when the subscription has been terminated by the server
      },

      received(data) {
        // Broadcast fields are untrusted, including filenames and profile metadata.
        const escapeHtml = value => String(value == null ? '' : value).replace(/[&<>"']/g, character => ({
          '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
        }[character]));
        const safeUrl = value => {
          try {
            const url = new URL(value, window.location.origin);
            return ['https:', 'http:'].includes(url.protocol) ? escapeHtml(url.href) : '';
          } catch (_) { return ''; }
        };
        if (!/^\d+$/.test(String(data.room_id)) || !/^\d+$/.test(String(data.message_id))) return;

        const roomId = data.room_id;
        const latestMessage = data.message;
        const messageDate = data.message_date || new Date().toISOString().slice(0, 10);

        const unreadCountElement = $(`[data-room-id="${roomId}"] .dot-count`);
        const currentCount = parseInt(unreadCountElement.text()) || 0;

        const roomMessageContainer = $(`#room-${data.room_id}`);
        const isSender = data.sender_profile_id === currentUserId && data.sender_profile_type === currentUserType;
        const messageClass = isSender ? 'message-sender' : 'message-receiver';
        const username = data.sender_initials;
        const roomListContainer = document.getElementById('rooms-list') || document.getElementById('shipper-rooms-list');
        const translationSource = roomListContainer || document.getElementById('current-user');
        const fileSentText = (translationSource && translationSource.dataset.fileSentText) || '';
        const imageSentText = (translationSource && translationSource.dataset.imageSentText) || '';
        const noMessagesYetText = (translationSource && translationSource.dataset.noMessagesYetText) || '';
        const previewContainer = document.getElementById('file-preview-container');
        if (previewContainer) {
          previewContainer.classList.add('d-none');
        }

        const imageExtensionsSet = new Set([
          'jpg','jpeg','png','gif','bmp','webp','heic','heif',
          'tiff','tif','avif','jfif','raw','dng','cr2','nef','arw'
        ]);
        function isImageAttachment(attachment) {
          if (attachment.content_type && attachment.content_type.startsWith('image/')) return true;
          const ext = (attachment.filename || '').split('.').pop().toLowerCase();
          return imageExtensionsSet.has(ext);
        }

        const attachmentHtml = data.attachment && data.attachment.content_type ? `
          <div class="attachment-container" style="margin-top: 5px;">
            ${isImageAttachment(data.attachment) ? `
              <div class="img-preview-container">
                <img class="img-preview" src="${safeUrl(data.attachment.thumb_url || data.attachment.url)}" alt="${escapeHtml(data.attachment.filename)}" data-image-url="${safeUrl(data.attachment.url)}" data-image-download-url="${safeUrl(data.attachment.download_url || data.attachment.url)}" data-image-filename="${escapeHtml(data.attachment.filename)}" style="display: block; width: 240px; height: 240px; object-fit: cover; border-radius: 8px; cursor: zoom-in;" onerror="this.onerror=null; this.src=this.dataset.imageUrl;">
              </div>
            ` : data.attachment.content_type.startsWith('video/') ? `
              <div class="video-preview-container">
                <video controls class="video-preview">
                  <source src="${safeUrl(data.attachment.url)}" type="${escapeHtml(data.attachment.content_type)}">
                  Your browser does not support the video tag.
                </video>
              </div>
            ` : `
              <div class="file-link-container">
                <a href="${safeUrl(data.attachment.download_url || data.attachment.url)}" class="file-link">${escapeHtml(data.attachment.filename)}</a>
              </div>
            `}
          </div>
        ` : '';

        addMessageToRoom();
        function isValidUrl(url) {
          const pattern = /^(https?:\/\/)[^\s/$.?#].[^\s]*$/i;
          return pattern.test(url);
        }
        function truncateText(text, maxLength) {
          return text.length > maxLength ? text.substring(0, maxLength) + "..." : text;
        }
        function previewTextForRoom(message, attachment) {
          const messageText = (message || '').trim();
          if (messageText.length > 0) {
            return truncateText(messageText, 50);
          }

          if (attachment && attachment.content_type) {
            return attachment.content_type.startsWith('image/') ? imageSentText : fileSentText;
          }

          return noMessagesYetText;
        }
        function formatMessageDateLabel(dateString) {
          if (!dateString) return "Today";

          const [year, month, day] = dateString.split("-").map(Number);
          const messageDay = new Date(year, month - 1, day);
          const today = new Date();
          const todayOnly = new Date(today.getFullYear(), today.getMonth(), today.getDate());
          const yesterdayOnly = new Date(todayOnly);
          yesterdayOnly.setDate(todayOnly.getDate() - 1);

          if (messageDay.getTime() === todayOnly.getTime()) return "Today";
          if (messageDay.getTime() === yesterdayOnly.getTime()) return "Yesterday";

          return messageDay.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
        }
        function addMessageToRoom() {
          const optimisticMsg = document.getElementById('message-optimistic');
          if (optimisticMsg) optimisticMsg.remove();

          if ($(`#message-${data.message_id}`).length > 0) {
            return;
          }
          const previewText = previewTextForRoom(latestMessage, data.attachment);
          const previewElement = $(`[data-room-id="${roomId}"] .room-last-message`);
          if (previewElement.length > 0) {
            previewElement.text(previewText);
          } else {
            $(`[data-room-id="${roomId}"] .mb-0`).text(previewText);
          }

          const messageRowClass = isSender ? 'message-row d-flex flex-row-reverse w-100' : 'message-row d-flex flex-row align-items-start w-100';
          const contentContainerClass = isSender ?
            'message-content-container d-flex flex-column align-items-end mr-0 message-bubble sender-bubble' :
            'message-content-container d-flex flex-column align-items-start ml-2 message-bubble receiver-bubble';

          const lastRenderedDate = roomMessageContainer.find('.message').last().data('message-date');
          if (lastRenderedDate !== messageDate) {
            roomMessageContainer.append(`
              <div class="chat-date-divider" data-message-date="${escapeHtml(messageDate)}">
                <span>${formatMessageDateLabel(messageDate)}</span>
              </div>
            `);
          }

          roomMessageContainer.append(`
            <div class="message mb-3 ${messageClass}" id="message-${data.message_id}" data-message-date="${escapeHtml(messageDate)}">
              <div class="align-items-end">
                <div class="${messageRowClass}">
                  <div class="message-img-holder mr-0">
                  <div class="img-fluid shadow rounded-circle" style="display: inline-block;">
                  <span class="default-profile">
                    ${isValidUrl(data.sender_profile_pic) 
                      ? `<img class="img-fluid default-profile" src="${safeUrl(data.sender_profile_pic)}" alt="Profile Picture">`
                      : `${escapeHtml(username)}`}
                  </span>
                  </div>
                  </div>
                  <div class="${contentContainerClass}">
                    ${data.message ? `<p class="message-content m-0 f-sm-11">${escapeHtml(data.message)}</p>` : ''}
                    ${attachmentHtml}
                    <span class="message-time">${escapeHtml(data.timestamp)}</span>
                  </div>
                </div>
              </div>
            </div>
          `);

          const newCount = isSender ? currentCount : currentCount + 1;
          unreadCountElement.text(newCount);
          if (newCount > 0) unreadCountElement.show();
          if (parseInt(unreadCountElement.text()) === 0) unreadCountElement.hide();

          if (!isSender) {
            const roomListElement = $(`[data-room-id="${roomId}"]`);
            const tripKey = roomListElement.attr('data-trip-key');
            if (tripKey) {
              const tripUnreadElement = $(`#trip-unread-count-${tripKey}`);
              const tripCurrentCount = parseInt(tripUnreadElement.text(), 10) || 0;
              const tripNewCount = tripCurrentCount + 1;
              tripUnreadElement.text(tripNewCount).css('display', 'inline-flex');
            }
          }

          $('.message-type-box').scrollTop($('.message-type-box').prop("scrollHeight"));
          $('#message_content').val('');
          $('#file-preview-container').html(''); 
          $('#upload').val('');
          $(`#last-message-date-${roomId}`).text(data.last_message_date);
          $('#file-preview-container').addClass('d-none');

          if (typeof window.refreshPublicGuestComposerForRoom === 'function') {
            window.refreshPublicGuestComposerForRoom(roomId);
          }
        }
      }
    });
  });

  // Hide notifications after 2 seconds
  $(".alert-holder").fadeTo(2000, 500).slideUp(500, function() {
    $(".alert-holder").slideUp(500);
  });

  $(document).click(function(event) {
    if(!$(event.target).closest('.navbar-collapse').length && !$(event.target).is('.navbar-toggler')) {
      if($('.navbar-collapse').hasClass('show')) {
          $('.navbar-collapse').removeClass('show');
      }
    }           
  });

  $('.default-profile').click(function () {
    $('.navbar-collapse').removeClass('show');
  });
});

$(document).on('turbolinks:load', function() {
  const dataTableInfo = $('.dataTables_info');
  if (dataTableInfo) {
    dataTableInfo.remove();
  }
  // Per page item selection for sender active orders dashboard.
  $('#senderDashboardItemsCount').change(function() {
    // Get the selected value
    var selectedValue = $(this).val();
    if(selectedValue) {
      $.ajax({
        type: "GET",
        contentType: "application/json",
        dataType: 'script',  
        url: "/senders/dashboard",
        data: { pagy_items_count: selectedValue }   
      });
    }
  });
  // Per page item selection for sender Pending orders dashboard.
  $('#senderDashboardPendingCount').change(function() {
    // Get the selected value
    var selectedValue = $(this).val();
    if(selectedValue) {
      $.ajax({
        type: "GET",
        contentType: "application/json",
        dataType: 'script',  
        url: "/senders/dashboard",
        data: { pagy_items_pending_count: selectedValue }   
      });
    }
  });

  $('#senderDashboardPurchasePendingCount').change(function() {
    // Get the selected value
    var selectedValue = $(this).val();
    if(selectedValue) {
      $.ajax({
        type: "GET",
        contentType: "application/json",
        dataType: 'script',  
        url: "/senders/dashboard",
        data: { purchase_pagy_items_pending_count: selectedValue }   
      });
    }
  });

  $('#senderDashboardPurchaseItemsCount').change(function() {
    // Get the selected value
    var selectedValue = $(this).val();
    if(selectedValue) {
      $.ajax({
        type: "GET",
        contentType: "application/json",
        dataType: 'script',  
        url: "/senders/dashboard",
        data: { sender_purchase_count: selectedValue }   
      });
    }
  });

  // Per page item selection for Forwarder Dashboard Pending orders.
  $('#ForwarderDashboardPendingCount').change(function() {
    // Get the selected value
    var selectedValue = $(this).val();
    if(selectedValue) {
      $.ajax({
        type: "GET",
        contentType: "application/json",
        dataType: 'script',  
        url: "/shippers/forwarders/dashboards",
        data: { shipping_pending_count: selectedValue }   
      });
    }
  });

  $('#ForwarderDashboardPurchasePendingCount').change(function() {
    var selectedValue = $(this).val();
    if(selectedValue) {
      $.ajax({
        type: "GET",
        contentType: "application/json",
        dataType: 'script',  
        url: "/shippers/forwarders/dashboards",
        data: { purchase_pending_count: selectedValue }   
      });
    }
  });

   // Per page item selection for Forwarder Dashboard Active orders.
  $('#ForwarderDashboardActiveCount').change(function() {
    // Get the selected value
    var selectedValue = $(this).val();
    if(selectedValue) {
      $.ajax({
        type: "GET",
        contentType: "application/json",
        dataType: 'script',  
        url: "/shippers/forwarders/dashboards",
        data: { shipping_active_count: selectedValue }   
      });
    }
  });

  $('#ForwarderDashboardPurchaseActiveCount').change(function() {
    // Get the selected value
    var selectedValue = $(this).val();
    if(selectedValue) {
      $.ajax({
        type: "GET",
        contentType: "application/json",
        dataType: 'script',  
        url: "/shippers/forwarders/dashboards",
        data: { purchase_active_count: selectedValue }   
      });
    }
  });

  $('#TravelersDashboardPendingCount').change(function() {
    // Get the selected value
    var selectedValue = $(this).val();
    if(selectedValue) {
      $.ajax({
        type: "GET",
        contentType: "application/json",
        dataType: 'script',  
        url: "/shippers/travelers/dashboards",
        data: { travelers_items_pending_count: selectedValue }   
      });
    }
  });

  $('#TravelersDashboardPurchasingPendingCount').change(function() {
    var selectedValue = $(this).val();
    if(selectedValue) {
      $.ajax({
        type: "GET",
        contentType: "application/json",
        dataType: 'script',  
        url: "/shippers/travelers/dashboards",
        data: { travelers_purchase_pending_count: selectedValue }   
      });
    }
  });

  $('#TravelersDashboardActiveCount').change(function() {
    var selectedValue = $(this).val();
    if(selectedValue) {
      $.ajax({
        type: "GET",
        contentType: "application/json",
        dataType: 'script',  
        url: "/shippers/travelers/dashboards",
        data: { travelers_items_active_count: selectedValue }   
      });
    }
  });

  $('#TravelersDashboardPurchaseCount').change(function() {
    var selectedValue = $(this).val();
    if(selectedValue) {
      $.ajax({
        type: "GET",
        contentType: "application/json",
        dataType: 'script',  
        url: "/shippers/travelers/dashboards",
        data: { travelers_purchase_active_count: selectedValue }   
      });
    }
  })
  $(document).on('change', '#PurchaseOrdersItemsCount', function() {
    var selectedValue = $(this).val();
    if(selectedValue) {
      var activeHref = $('#purchasing_items .nav-link.active').attr('href');
      var statusParam = getParameterByName('status', activeHref);
      var requestData = { travelers_purchase_items_active_count: selectedValue, tabs: 'purchase' };
      if (statusParam) {
        requestData.status = statusParam;
      }
      $.ajax({
        type: "GET",
        contentType: "application/json",
        dataType: 'script',  
        url: "/shippers/travelers/orders",
        data: requestData
      });
    }
  });
  


  function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
          results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  $(document).on('change', '#travelersDashboardItemsCount', function() {
    var selectedValue = $(this).val();
    const activeHref = $('#shipping_items .nav-link.active').attr('href');
    const statusParam = getParameterByName('status', activeHref);
    if (selectedValue){
      const requestData = { pagy_items_count: selectedValue, tabs: 'shipping' };
      if (statusParam) {
        requestData.status = statusParam;
      }
      $.ajax({
        type: "GET",
        contentType: "application/json",
        dataType: 'script',
        url: "/shippers/travelers/orders",
        data: requestData
      });
    }
  });
  
  $(document).on('change', '#publicTripItemsCount', function() {
    var selectedValue = $(this).val();
    if(selectedValue) {
      var requestData = $('.form-filter').serializeArray().reduce(function(data, field) {
        if (field.value) data[field.name] = field.value;
        return data;
      }, {});
      requestData.pagy_items_count = selectedValue;

      $.ajax({
        type: "GET",
        contentType: "application/json",
        dataType: 'script',  
        url: "/public/trips",
        data: requestData
      });
    }
  });

  $(document).on('change', "#FeedbackItemsCount",function () {
    var selectedValue = $(this).val();
    var userRole = $(this).data('name')
    if (selectedValue && userRole) {
      $.ajax({
        type: "GET",
        contentType: "application/json",
        dataType: "script",
        url: `/users/feedbacks/${userRole}`,
        data: { pagy_items_count: selectedValue },
      });
    }
  });
  
  // Per page item selection for sender company trips dashboard.
  $('#senderDashboardCompanyItemsCount').change(function() {
    var selectedValue = $(this).val();
    const statusParam = getParameterByName('status');
    if(selectedValue && statusParam) {
      $.ajax({
        type: "GET",
        contentType: "application/json",
        dataType: 'script',  
        url: "/senders/dashboard",
        data: { pagy_company_items_count: selectedValue, status: statusParam }   
      });
    }else{
      if(selectedValue) {
        $.ajax({
          type: "GET",
          contentType: "application/json",
          dataType: 'script',  
          url: "/senders/dashboard",
          data: { pagy_company_items_count: selectedValue }   
        });
      }

    }
  });

  // Per page item selection for sender order.
  $(document).on('change', '#senderOrdersItemsCount', function() {
    var selectedValue = $(this).val();
    const statusParam = getParameterByName('status');
    if(selectedValue && statusParam) {
      $.ajax({
        type: "GET",
        contentType: "application/json",
        dataType: 'script',  
        url: "/senders/orders",
        data: { pagy_items_count: selectedValue, status: statusParam }   
      });
    }else{
      if(selectedValue) {
        $.ajax({
          type: "GET",
          contentType: "application/json",
          dataType: 'script',  
          url: "/senders/orders",
          data: { pagy_items_count: selectedValue}   
        });
      }
    }
  });

  $(document).on('change', '#SenderPurchaseOrdersItemsCount',function() {
    var selectedValue = $(this).val();
    if(selectedValue) {
      $.ajax({
        type: "GET",
        contentType: "application/json",
        dataType: 'script',  
        url: "/senders/orders",
        data: { pagy_items_count: selectedValue}   
      });
    }
  });

  $(document).on('change', '#forwarderDashboardItemsCount', function() {
    var selectedValue = $(this).val();
    const activeHref = $('#shipping_items .nav-link.active').attr('href');
    const statusParam = getParameterByName('status', activeHref);
    if (selectedValue) {
      const requestData = { pagy_items_count: selectedValue, tabs: 'shipping' };
      if (statusParam) {
        requestData.status = statusParam;
      }
      $.ajax({
        type: "GET",
        contentType: "application/json",
        dataType: 'script',
        url: "/shippers/forwarders/orders",
        data: requestData
      });
    }
  });

  $(document).on('change', '#forwarderPurchaseItemsCount', function() {  
    var selectedValue = $(this).val();
    if (selectedValue) {
      var activeHref = $('#purchasing_items .nav-link.active').attr('href');
      var statusParam = getParameterByName('status', activeHref);
      var requestData = { for_pagy_items_count: selectedValue, tabs: 'purchase' };
      if (statusParam) {
        requestData.status = statusParam;
      }
      $.ajax({
        type: "GET",
        contentType: "application/json",
        dataType: 'script',  
        url: "/shippers/forwarders/orders",
        data: requestData
      });  
    }
  });

  // feedback rating
  $(".rating input:radio").attr("checked", false);

  $(".rating input").click(function () {
    $(".rating span").removeClass("checked");
    $(this).parent().addClass("checked");
  });

  $("input:radio").change(function () {
    var userRating = this.value;
    $("#feedback_rating").val(userRating);
  }); 

  $(document).on('change', '#SenderPurchasingOrderHistoryCount', function() {
    var selectedValue = $(this).val();
    var ownerId = $(this).data('owner-id');
    if(selectedValue) {
      $.ajax({
        type: "GET",
        contentType: "application/json",
        dataType: 'script',  
        url: "/senders/orders/order_history",
        data: { purchasing_order_history_count: selectedValue,owner_id: ownerId }   
      });
    }
  })
});
